require('./depositsBoxHeader.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const classNames = require('classnames');
import moment from 'moment';
// @ commons
const { FormattedText } = require('core/i18n').i18n;
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const OKTag = require('components/commons/OKTag/OKTag');
const WebappRender = require('components/conditionalRender/webappRender');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
//@core
const { getLanguage } = require('core/i18n').i18n;
// @ helpers
const { toCamelCase } = require('utilities/stringHelper');
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
const language = getLanguage();
import { getDateCamelCaseShortMonth } from 'utilities/dateHelper';

class DepositsBoxHeader extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    getOwnerStatus() {
        const { immDeposit } = this.props;
        if (!immDeposit.get('isHolder')){
            return (
                <OKTag
                    content="depositsBox-authorized"
                    context="arrow"
                />
            );
        }
    }

    buildEstimated(){ //TODO future Estimated
        const plainAmountObject = getPlainAmountObject({amount:"10000", currency:"EUR"});

        return (
            <div className="deposits-box-header__estimated-header">
                <FormattedText className="deposits-box-header__estimated-taxes" value="depositsBox-estimatedTaxes"/>
                <OneLineSymbolAmount
                    amountObject={plainAmountObject}
                    className="deposits-box-header__estimated-amount"
                    language={language}
                    amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                />
            </div>);
    }

    render() {
        let iAmOwnerTag = this.getOwnerStatus();

        const { immDeposit, index, isExpanded } = this.props;
        const description = immDeposit.get('description');
        const alias = __CONTACT_CENTER__ ? immDeposit.getIn(['contract','fullContractNumber']) : immDeposit.get('alias');
        const amount = immDeposit.get('amount').toJS();
        const plainAmountObject = getPlainAmountObject(amount);
        const descriptionClassname = classNames('deposits-box-header__description', {
            'deposits-box-header__description--expanded': !__CONTACT_CENTER__ && isExpanded,
          });
        return (
            <div className="deposits-box-header" id={'deposits-box-' + index}>
                <section>
                    <div className="clearfix">
                        <div className="pull-left">
                            <div className={descriptionClassname}>
                                {toCamelCase(description)}
                            </div>
                            <ContactCenterRender>
                                <span className="deposits-box-header__type">
                                    {iAmOwnerTag}
                                </span>
                            </ContactCenterRender>
                            <div className="deposits-box-header__alias-header">
                                <span className="deposits-box-header__alias">{alias}</span>
                            </div>
                            <WebappRender>
                                <span className="deposits-box-header__type">
                                    {iAmOwnerTag}
                                </span>
                            </WebappRender>
                        </div>
                        <div className="deposits-box-header__contract-data pull-right">
                            <div className="deposits-box-header__contract-data-item">
                                <WebappRender>
                                    <div className="deposits-box-header__amount-value">
                                        {getDateCamelCaseShortMonth(immDeposit.get('closestExpirationDate'))}
                                    </div>
                                </WebappRender>
                            </div>
                            <div className="deposits-box-header__contract-data-item">
                                <OneLineSymbolAmount
                                    amountObject={plainAmountObject}
                                    className="deposits-box-header__amount-value"
                                    language={language}
                                    amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                                />
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

DepositsBoxHeader.propTypes = {
    immDeposit: PropTypes.object.isRequired,
    index: PropTypes.string.isRequired,
    isExpanded: PropTypes.bool.isRequired,
};

module.exports = DepositsBoxHeader;
